export enum OrderProposalStatusEnum {
  SCHEDULED = 'SCHEDULED',
  PENDING_ADVANCE = 'PENDING_ADVANCE',
  CONFIRMED = 'CONFIRMED',
}

export enum OrderProductionStatusEnum {
  PRODUCTION = 'PRODUCTION',
}

export enum OrderOtherStatusEnum {
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
}

export type OrderStatus = OrderProposalStatusEnum
| OrderProductionStatusEnum
| OrderOtherStatusEnum

type OrderStatusDisplay = {
  name: string
  color: string
}

export const OrderStatusDisplayMapping: Record<
OrderStatus,
OrderStatusDisplay
> = {
  [OrderProposalStatusEnum.SCHEDULED]: {
    name: 'Agendamento',
    color: 'default',
  },
  [OrderProposalStatusEnum.PENDING_ADVANCE]: {
    name: 'Pendente',
    color: 'warning',
  },
  [OrderProposalStatusEnum.CONFIRMED]: {
    name: 'Confirmado',
    color: 'processing',
  },
  [OrderProductionStatusEnum.PRODUCTION]: {
    name: 'Produção',
    color: 'processing',
  },
  [OrderOtherStatusEnum.FINISHED]: {
    name: 'Entregue',
    color: 'success',
  },
  [OrderOtherStatusEnum.CANCELED]: {
    name: 'Cancelado',
    color: 'error',
  },
};

export enum OrderViewStatusEnum {
  PROPOSAL = 'PROPOSAL',
  NON_CANCELED = 'NON_CANCELED',
}

export type OrderApiStatus = OrderStatus | OrderViewStatusEnum

export enum OrderTypeEnum {
  REGULAR = 'REGULAR',
  GRAFTING = 'GRAFTING',
}

type OrderTypeDisplay = {
  name: string
}

export const OrderTypeDisplayMapping: Record<OrderTypeEnum, OrderTypeDisplay> = {
  [OrderTypeEnum.REGULAR]: {
    name: 'Pé Franco',
  },
  [OrderTypeEnum.GRAFTING]: {
    name: 'Enxertia',
  },
};

export enum DeliveryTypeEnum {
  DELIVERY = 'DELIVERY',
  TAKEOUT = 'TAKEOUT',
}

type DeliveryTypeDisplay = {
  name: string
}

export const DeliveryTypeDisplayMapping: Record<DeliveryTypeEnum, DeliveryTypeDisplay> = {
  [DeliveryTypeEnum.DELIVERY]: {
    name: 'Frete',
  },
  [DeliveryTypeEnum.TAKEOUT]: {
    name: 'Retirada',
  },
};

export enum OrderUnitEnum {
  UNIT = 'UNIT',
  TRAY = 'TRAY',
  THOUSAND = 'THOUSAND',
}

type OrderUnitDisplay = {
  name: string
  namePlural: string
  smallName: string
}

export const OrderUnitDisplayMapping: Record<OrderUnitEnum, OrderUnitDisplay> = {
  [OrderUnitEnum.UNIT]: {
    name: 'Unidade',
    namePlural: 'Unidades',
    smallName: 'UN',
  },
  [OrderUnitEnum.TRAY]: {
    name: 'Bandeja',
    namePlural: 'Bandejas',
    smallName: 'UN',
  },
  [OrderUnitEnum.THOUSAND]: {
    name: 'Mil',
    namePlural: 'Mil',
    smallName: 'MX',
  },
};

export enum OrderStumpTypeEnum {
  DISCARD = 'DISCARD',
  GRAFT = 'GRAFT',
  STORE = 'STORE',
}

type OrderStumpTypeDisplay = {
  name: string
}

export const OrderStumpTypeDisplayMapping: Record<OrderStumpTypeEnum, OrderStumpTypeDisplay> = {
  [OrderStumpTypeEnum.DISCARD]: {
    name: 'Descartar',
  },
  [OrderStumpTypeEnum.GRAFT]: {
    name: 'Enxertar',
  },
  [OrderStumpTypeEnum.STORE]: {
    name: 'Guardar',
  },
};

export enum OrderItemApiStatusEnum {
  SCHEDULED = 'SCHEDULED',
  PENDING_ADVANCE = 'PENDING_ADVANCE',
  CONFIRMED = 'CONFIRMED',
  SEEDING = 'SEEDING',
  PRODUCTION = 'PRODUCTION',
  DELIVERY = 'DELIVERY',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  NON_CANCELED = 'NON_CANCELED',
}

export type OrderItemInternalOrderStatus = OrderProposalStatusEnum.CONFIRMED
| OrderProposalStatusEnum.PENDING_ADVANCE
| OrderProposalStatusEnum.SCHEDULED
| OrderOtherStatusEnum.CANCELED;

export type OrderItemInternalProductionItemStatus = ProductionItemStatusEnum.CONFIRMED
| ProductionItemStatusEnum.SEEDING
| ProductionItemStatusEnum.PRODUCTION
| ProductionItemStatusEnum.DELIVERY
| ProductionItemStatusEnum.FINISHED;

type OrderItemApiStatusDisplay = {
  name: string
  color: string
}

export const OrderItemApiStatusDisplayMapping: Record<
OrderItemApiStatusEnum,
OrderItemApiStatusDisplay
> = {
  [OrderItemApiStatusEnum.SCHEDULED]: {
    name: 'Agendamento',
    color: 'default',
  },
  [OrderItemApiStatusEnum.PENDING_ADVANCE]: {
    name: 'Pendente',
    color: 'warning',
  },
  [OrderItemApiStatusEnum.CONFIRMED]: {
    name: 'Confirmado',
    color: 'processing',
  },
  [OrderItemApiStatusEnum.SEEDING]: {
    name: 'Semeio',
    color: 'processing',
  },
  [OrderItemApiStatusEnum.PRODUCTION]: {
    name: 'Desenvolvimento',
    color: 'processing',
  },
  [OrderItemApiStatusEnum.DELIVERY]: {
    name: 'Entrega',
    color: 'processing',
  },
  [OrderItemApiStatusEnum.FINISHED]: {
    name: 'Finalizado',
    color: 'success',
  },
  [OrderItemApiStatusEnum.CANCELED]: {
    name: 'Cancelado',
    color: 'error',
  },
  [OrderItemApiStatusEnum.NON_CANCELED]: {
    name: '',
    color: '',
  },
};

export enum ProductionItemStatusEnum {
  CONFIRMED = 'CONFIRMED',
  SEEDING = 'SEEDING',
  PRODUCTION = 'PRODUCTION',
  DELIVERY = 'DELIVERY',
  FINISHED = 'FINISHED',
}

type ProductionItemStatusDisplay = {
  name: string
  color: string
}

export const ProductionItemStatusDisplayMapping: Record<
ProductionItemStatusEnum,
ProductionItemStatusDisplay
> = {
  [ProductionItemStatusEnum.CONFIRMED]: {
    name: 'Confirmado',
    color: 'processing',
  },
  [ProductionItemStatusEnum.SEEDING]: {
    name: 'Semeio',
    color: 'processing',
  },
  [ProductionItemStatusEnum.PRODUCTION]: {
    name: 'Desenvolvimento',
    color: 'processing',
  },
  [ProductionItemStatusEnum.DELIVERY]: {
    name: 'Entrega',
    color: 'processing',
  },
  [ProductionItemStatusEnum.FINISHED]: {
    name: 'Finalizado',
    color: 'success',
  },
};

export enum ProductionItemSeedStatusEnum {
  UNAVAILABLE = 'UNAVAILABLE',
  WAITING = 'WAITING',
  AVAILABLE = 'AVAILABLE',
  OK = 'OK',
}

type ProductionItemSeedStatusDisplay = {
  name: string
  color: string
}

export const ProductionItemSeedStatusDisplayMapping: Record<
ProductionItemSeedStatusEnum,
ProductionItemSeedStatusDisplay
> = {
  [ProductionItemSeedStatusEnum.UNAVAILABLE]: {
    name: 'Indisponível',
    color: 'error',
  },
  [ProductionItemSeedStatusEnum.WAITING]: {
    name: 'Aguardando',
    color: 'error',
  },
  [ProductionItemSeedStatusEnum.AVAILABLE]: {
    name: 'Em estoque',
    color: 'warning',
  },
  [ProductionItemSeedStatusEnum.OK]: {
    name: 'OK',
    color: 'success',
  },
};

export enum SeedTicketStatusEnum {
  REQUESTED = 'REQUESTED',
  PENDING = 'PENDING',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
}

export enum SeedingBatchTypeEnum {
  MAIN = 'MAIN',
  REMAINING = 'REMAINING',
}

export enum SeedingBatchStatusEnum {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
}

type SeedingBatchStatusDisplay = {
  name: string
  color: string
}

export const SeedingBatchStatusDisplayMapping: Record<
SeedingBatchStatusEnum,
SeedingBatchStatusDisplay
> = {
  [SeedingBatchStatusEnum.PENDING]: {
    name: 'Pendente',
    color: 'warning',
  },
  [SeedingBatchStatusEnum.CONFIRMED]: {
    name: 'Confirmado',
    color: 'success',
  },
};
